import { formatMessage } from "lib/globalize-util";
import { Validator } from "helpers/validator";
import { sanitizeHeaderNames } from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/utils";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";
import { MAX_ATTRIBUTE_NAME_LENGTH } from "helpers/utils/constants";

export class AttributeNameLengthRule extends Validator<IAttributeData[], IAttributeDataError> {
    constructor() {
        super();
    }

    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        const hasInvalidCharacterError = errors[RuleType.AttributeValidNameRule];
        const headers = sanitizeHeaderNames(Object.keys(model[0] || {}));
        const hasExceededNameLengthLimit = headers.some((key) => key.length > MAX_ATTRIBUTE_NAME_LENGTH);

        if (!hasInvalidCharacterError && hasExceededNameLengthLimit) {
            const validationErrors = {
                ...errors,
                [RuleType.AttributeNameLengthRule]: formatMessage(
                    "Your file has a attribute name with more than |limit| characters, the maximum supported character limit is |limit|",
                    {
                        limit: MAX_ATTRIBUTE_NAME_LENGTH,
                    }
                ),
            };

            return super.validate(model, validationErrors);
        }

        return super.validate(model, errors);
    }
}
